// extracted by mini-css-extract-plugin
export default {"container":"style_container__p+Cz3","multiple":"style_multiple__SjxoM","title":"style_title__TvtTj","content":"style_content__ppW-h"};